import { render } from "./LinkEventosOrcamentoModal.vue?vue&type=template&id=6b2d16ed"
import script from "./LinkEventosOrcamentoModal.vue?vue&type=script&lang=js"
export * from "./LinkEventosOrcamentoModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\senar-sgo\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__